import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { RodeoEventRegistration } from '../model/rodeoEventRegistration';

@Injectable()
export class EntryService {
    deleted: number[] = [];

    constructor(private api: ApiService) {

    }

    async getEntry(id: number) {
        const url = `${this.api.endpoints.entries}/getEntry?id=${id}`;
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(url)
                .then(data => resolve(data), error => reject(error));
        });
    }

    async getEntries(accountId: number, searchOptions, skip: number) {
        return await
            this.api
                .postWithAuth(this.api.endpoints.entries + '/getEntries?accountId=' + accountId + '&skip=' + skip, searchOptions);
    }

    async getEntryLogs(entryId: number) {
        try {
            return await this.api.getWithAuth(`${this.api.endpoints.entries}/getEntryLogs?registrationId=${entryId}`);
        } catch (err) {
            console.error('EntryService - getEntryLogs', err);
            return [];
        }
    }

    getUpdatedRegistrationsNew(rodeoId: number, regUpdateInfo: any) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.entries + '/getUpdatedRegistrationsNew?rodeoId=' + rodeoId, regUpdateInfo)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getUpdatedRegistrations(rodeoEventId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.entries + '/getUpdatedRegistrations?rodeoEventId=' + rodeoEventId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getUpdatedRodeoRegistrations(rodeoId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.entries + '/getUpdatedRodeoRegistrations?rodeoId=' + rodeoId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    createEntry(entry: RodeoEventRegistration) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.entries + '/create', entry)
                .then(data => resolve(data), error => reject(error));
        });
    }

    staffCreateEntries(entries: RodeoEventRegistration[], staffBypass, paymentMethod = 'stripe', drawPosition) {
        const url = `${this.api.endpoints.entries}/staffCreateEntries?staffBypass=${staffBypass}&paymentMethod=${paymentMethod}&drawPosition=${drawPosition}`
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(url, entries)
                .then(data => resolve(data), error => reject(error));
        });
    }

    staffCreateEntry(entry: RodeoEventRegistration[], staffBypass) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.entries + '/staffCreate?staffBypass=' + staffBypass, entry)
                .then(data => resolve(data), error => reject(error));
        });
    }

    deleteEntry(entryId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.entries + '/delete?id=' + entryId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    deleteEntries(entryIds: number[]) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.entries + '/deleteEntries', entryIds)
                .then(data => resolve(data), error => reject(error));
        });
    }

    updateEntry(entry: RodeoEventRegistration) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.entries + '/update', entry)
                .then(data => resolve(data), error => reject(error));
        });
    }

    staffUpdateEntry(entry: RodeoEventRegistration, staffBypass, paymentMethod = 'stripe', drawPosition) {
        const url = `${this.api.endpoints.entries}/staffUpdate?staffBypass=${staffBypass}&paymentMethod=${paymentMethod}&drawPosition=${drawPosition}`;
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(url, entry)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getUpdatedEntries(eventId: number, categoryId: number, lastUpdate: any) {
        return new Promise((resolve, reject) => {
            this.api
                .putWithAuth(this.api.endpoints.entries + '/getUpdatedEntries?eventId=' + eventId + '&categoryId=' + categoryId + '&lastUpdate=' + lastUpdate)
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/entry.service.ts